import "@lottiefiles/lottie-player";
import lottie from 'lottie-web';

const config = {
  rootMargin: '50px 20px 75px 30px',
  threshold: [0, 0.25, 0.75, 1],
};

function loadLottie(animationName, targetSelector) {
  const container = document.querySelector(targetSelector);
  if (!container) {
    return;
  }

  const autoplay = container.classList.contains('lottie-autoplay');
  const loop = container.classList.contains('lottie-loop');

  const animation = lottie.loadAnimation({
    container,
    path: `/octopus-public/animations/${animationName}.json`,
    renderer: 'svg',
    loop,
    autoplay,
  });

  if (container.classList.contains('lottie-show-end-frame')) {
    // Static Number for end frames as animation.totalFrames returns NaN.
    animation.goToAndStop(400, true);
  }

  if (container.classList.contains('lottie-play-on-hover')) {
    container.addEventListener('mouseenter', function (e) {
      if (animation.isPaused) {
        animation.goToAndPlay(0, true);
      }
    });
  }

  if (container.classList.contains('lottie-play-on-visible')) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.intersectionRatio > 0) {
          container.parentElement.classList.add('onscreen');
          animation.play();
        } else {
          animation.stop();
        }
      });
    }, config);

    observer.observe(container);
  }
}

if (document.querySelector('[data-lottie]')) {
  //lottie.useWebWorker(true);
  loadLottie('create-branch', '.lottie.createBranch');
  loadLottie('iterate-deploy', '.lottie.iterateDeploy');
  loadLottie('review-merge', '.lottie.reviewMerge');
  loadLottie('two-way-sync', '.lottie.twoWaySync');
};
